'use client';

import React from 'react';

export interface ToggleProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

export const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(
  (
    {
      checked = false,
      disabled = false,
      onChange,
      className = '',
      ...props
    },
    ref
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!disabled && onChange) {
        onChange(e.target.checked);
      }
    };

    return (
      <label
        className={`toggle-label ${disabled ? 'toggle-disabled' : ''} ${className}`}
      >
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={handleChange}
          className="toggle-input"
          {...props}
        />
        <span className={`toggle-switch ${checked ? 'toggle-checked' : ''}`}>
          <span className="toggle-knob" />
        </span>
      </label>
    );
  }
);

Toggle.displayName = 'Toggle';

export default Toggle;

